module.exports = __webpack_public_path__ + "img/logo2.82859c99.png";